import { useGraphQLQuery } from '@betterment/js-runtime';
import { Card, Heading } from '@betterment/samba-react';
import { CardLoader, ErrorBoundary } from '@betterment/shared-components';
import { useFallbackKeys } from '@betterment/shared-components/src/hooks/useFallbackKeys';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { PurposeActivityDocument } from './graphql/purposeActivity.generated';

import { Row } from '../../../activity/components';
import { ActivityLinkFooter } from '../../../Shared/components-v2/activity/overview-cards/ActivityLinkFooter';
import { NoActivityRow } from '../../../Shared/components-v2/activity/overview-cards/NoActivityRow';

export const ActivityCardView: React.FC = () => {
  const purposeId = useRequiredParam('purposeId');
  const { data } = useGraphQLQuery(PurposeActivityDocument, { variables: { id: purposeId }, throwOnError: true });
  const items = useFallbackKeys(data?.purpose.envelope.activity.items || []);

  if (!data) return <CardLoader />;

  const hasActivity = !!items.length;
  const accountIds = data.purpose.envelope.legalSubAccounts.map(a => a.legacySubAccountId.toString());

  return (
    <Card>
      <Card.Header css={{ padding: 'space.300' }}>
        <Heading as="h2" variant="title200">
          Recent activity
        </Heading>
      </Card.Header>
      <Card.Content>
        {hasActivity ? items.map(({ key, item }) => <Row key={key} item={item} />) : <NoActivityRow />}
      </Card.Content>
      {hasActivity && <ActivityLinkFooter accountIds={accountIds} />}
    </Card>
  );
};

export const ActivityCard: React.FC = () => (
  <ErrorBoundary fallbackType="none">
    <ActivityCardView />
  </ErrorBoundary>
);
